import React, { useState } from "react";
import { Globe2, Check } from "lucide-react";
import { useCurrency } from "../lib/currency";

const POPULAR = ["USD", "EUR", "GBP", "INR", "AUD", "CAD", "JPY", "BRL", "AED", "SGD"];

export default function CurrencyPicker() {
  const { currency, rates, country, setUserCurrency } = useCurrency();
  const [open, setOpen] = useState(false);

  const list = Object.keys(rates).sort((a, b) => {
    const ai = POPULAR.indexOf(a);
    const bi = POPULAR.indexOf(b);
    if (ai === -1 && bi === -1) return a.localeCompare(b);
    if (ai === -1) return 1;
    if (bi === -1) return -1;
    return ai - bi;
  });

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        data-testid="currency-toggle"
        className="inline-flex items-center gap-1.5 rounded-lg border border-zinc-200 bg-white px-2.5 py-1.5 text-xs font-medium text-zinc-700 hover:border-indigo-200 hover:text-indigo-700"
        title={`Detected from ${country}`}
      >
        <Globe2 className="h-3.5 w-3.5" />
        {currency}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div
            data-testid="currency-menu"
            className="absolute right-0 z-40 mt-2 max-h-72 w-44 overflow-y-auto rounded-xl border border-zinc-200 bg-white p-1 shadow-lg"
          >
            {list.map((c) => (
              <button
                key={c}
                onClick={() => { setUserCurrency(c); setOpen(false); }}
                data-testid={`currency-option-${c}`}
                className={`flex w-full items-center justify-between rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
                  currency === c ? "bg-indigo-50 text-indigo-700" : "text-zinc-700 hover:bg-zinc-50"
                }`}
              >
                <span>{c}</span>
                {currency === c && <Check className="h-3 w-3" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
